import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/soc-automations/')({
  beforeLoad: ({ context, params, preload }) => {
    const isAllowed = !!context.featureFlags[FeatureFlags.ShowAutomations];
    context.validatePermissions({ isAllowed, preload });
    throw redirect({ to: '/$accountId/threats/soc-automations/playbooks', search: true, params });
  },
});
